<glxy-badge
  matRipple
  [attr.aria-label]="label | translate"
  [attr.aria-selected]="selected"
  [ngClass]="'chip chip--' + size"
  [color]="color()"
>
  <span [class.hidden]="selected" [ngClass]="'chip-focus-overlay chip-focus-overlay--' + size"></span>
  <mat-icon *ngIf="chipIcon() as chipIcon" [ngClass]="'chip-icon chip-icon--' + size">
    {{ chipIcon }}
  </mat-icon>
  <span class="chip-label" [class.hidden]="hideLabel()">
    {{ label | translate }}
  </span>
</glxy-badge>
